<template>
  <div class="wrapper rtl public-shell" :class="{ 'dashboard-shell client-dashboard-shell': isClientDashboardRoute }">
    <div class="main-panel ">
      <top-navbar></top-navbar>
        <div class="content">
    <fade-transition :duration="100" mode="out-in">
      <!-- your content here -->
      <router-view></router-view>
    </fade-transition>
  </div>
      <content-footer></content-footer>
    </div>
  </div>


</template>
<style lang="scss">
.main-panel > .content {
  padding: 200px 0 0 0;
}
@media (max-width: 768px) {
  .main-panel > .content {
    padding: 50px 0 0 0;
  }
}
</style>
<script>
import Vue from "vue";
import TopNavbar from "./SampleNavbar.vue";
import ContentFooter from "./SampleFooter.vue";
export default {
  components: {
    TopNavbar,
    ContentFooter,
  },
  computed: {
    isClientDashboardRoute() {
      const user = Vue.$cookies.get("user");
      if (user?.type !== "CLIENT") {
        return false;
      }

      return ["/ddevis", "/devis", "/cmds", "/factures", "/avoirs"].includes(
        this.$route.path
      );
    },
  },

};
</script>
